import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import styles from './Sticky.module.scss';
function Sticky({ shadow, children }) {
    const [isSticky, setIsSticky] = useState(false);
    const ref = useRef(null);
    const sentinelRef = useRef(null);
    useEffect(() => {
        const observer = new IntersectionObserver(([entry]) => {
            // isSticky = true gdy sentinel element jest OUT of view (tzn. sticky się przykleja)
            setIsSticky(!entry.isIntersecting);
        }, { threshold: 0 });
        if (sentinelRef.current) {
            observer.observe(sentinelRef.current);
        }
        return () => {
            observer.disconnect();
        };
    }, []);
    const classes = classNames(styles.wrap, {
        [styles.showShadow]: shadow && isSticky,
    });
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { ref: sentinelRef }),
        React.createElement("div", { className: classes, ref: ref },
            React.createElement("div", { className: styles.children }, children))));
}
export default Sticky;
